'use client';

import { useTranslations } from 'next-intl';
import { useSuspenseQuery } from '@tanstack/react-query';

import { formatNumber } from '~/utils';
import { platformSettingsOptions } from '~/features/settings/querties';

type AsProp<T extends React.ElementType> = {
  as?: T;
};

type PropsToOmit<T extends React.ElementType, P> = keyof (AsProp<T> & P);

export type PolymorphicComponentProps<
  T extends React.ElementType,
  Props = object,
> = React.PropsWithChildren<Props & AsProp<T>> &
  Omit<React.ComponentPropsWithoutRef<T>, PropsToOmit<T, Props>>;

type TGstTagProps = {
  value: number;
};

type IGstTagProps<T extends React.ElementType = 'span'> =
  PolymorphicComponentProps<T, TGstTagProps>;

export function GstTag<T extends React.ElementType = 'span'>({
  as,
  value,
  ...props
}: IGstTagProps<T>) {
  const Comp = as ?? 'span';
  const t = useTranslations('models.adSpace.commons');
  const { data } = useSuspenseQuery(platformSettingsOptions());
  const { currencySign, taxRatePercentage } = data;

  return (
    <Comp {...props}>
      {t('tax')}: {currencySign}
      {formatNumber(value * taxRatePercentage)}
    </Comp>
  );
}
